import { baseApi } from "../baseApi";

export const Itemtaxapi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getDoctypeDetails: builder.query({
            query: (params) => ({
                url: `/api/method/frappe.client.get`,
                params: params
            })
        }),
        getAllcompany: builder.query({
            query: () => ({
                url: `/api/resource/Company`,
            })
        }),
        getAllAccounts: builder.query({
            query: () => ({
                url: `/api/method/frappe.desk.search.search_link`,
                params: {
                    doctype: "Account",
                    filters: JSON.stringify([
                        ["Account", "company", "=", "Stackerbee"],
                        ["Account", "is_group", "=", 0],
                        ["Account", "account_type", "in", [
                            "Tax",
                            "Chargeable",
                            "Income Account",
                            "Expense Account",
                            "Expenses Included In Valuation"
                        ]]
                    ]),
                    page_length: 100,
                    txt: ""
                }
            }),

        }),
getAllAccounts1: builder.query({
  query: ({ company }) => ({
    url: `/api/method/frappe.desk.search.search_link`,
    params: {
      doctype: "Account",
      filters: JSON.stringify([
        ["Account", "company", "=", company],
        ["Account", "is_group", "=", 0],
        [
          "Account",
          "account_type",
          "in",
          [
            "Tax",
            "Chargeable",
            "Income Account",
            "Expense Account",
            "Expenses Included In Valuation",
          ],
        ],
      ]),
      page_length: 100,
      txt: "",
    },
  }),
}),

        createItemTaxTemplate: builder.mutation({
            query: (body) => ({
                url: `/api/resource/Item Tax Template`,
                method: 'POST',
                body: body,
            }),
            invalidatesTags: ['Item Tax Template']
        }),
        getItemTaxTemplateslist: builder.query({
            query: ({ start = 0, limit = 12, filters = [] }) => {
                const fields = [
                    "`tabItem Tax Template`.`name`",
                    "`tabItem Tax Template`.`title`",
                    "`tabItem Tax Template`.`company`",
                    "`tabItem Tax Template`.`creation`",
                    "`tabItem Tax Template`.`modified`",
                    "`tabItem Tax Template`.`modified_by`",
                    "`tabItem Tax Template`.`owner`",
                    "`tabItem Tax Template`.`_user_tags`",
                    "`tabItem Tax Template`.`_comments`",
                    "`tabItem Tax Template`.`_assign`",
                    "`tabItem Tax Template`.`_liked_by`",
                    "`tabItem Tax Template`.`docstatus`",
                    "`tabItem Tax Template`.`idx`",
                    "`tabItem Tax Template`.`disabled`",
                ];

                const params = {
                    fields: JSON.stringify(fields),
                    limit_start: start,
                    limit_page_length: limit,
                    order_by: "`tabItem Tax Template`.`modified` desc",
                };

                if (filters.length > 0) {
                    params.filters = JSON.stringify(filters);
                }

                return {
                    url: `/api/resource/Item Tax Template`,
                    method: "GET",
                    params,
                };
            },
            providesTags: ['Item Tax Template'],
        }),

        getItemTaxTemplateByName: builder.query({
            query: (name) => ({
                url: `/api/resource/Item Tax Template/${encodeURIComponent(name)}`,
            }),
            providesTags: ['pon']
        }),
        updateItemTaxTemplate: builder.mutation({
            query: ({ name, data }) => ({
                url: `/api/resource/Item Tax Template/${encodeURIComponent(name)}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['pon', 'Item Tax Template']
        }),
        getItemtaxCount: builder.query({
            query: () => ({
                url: '/api/method/frappe.desk.reportview.get_count',
                params: {
                    doctype: 'Item Tax Template',
                },
            }),
        }),

    }),
});

export const { useGetItemtaxCountQuery, useUpdateItemTaxTemplateMutation, useGetItemTaxTemplateByNameQuery, useGetItemTaxTemplateslistQuery, useCreateItemTaxTemplateMutation, useGetAllcompanyQuery, useGetAllAccountsQuery,useGetAllAccounts1Query  } = Itemtaxapi;
